var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"car-image-name"},[_c('HoverImagePreview',{attrs:{"src":_vm.thumbImages[0]}}),_c('div',{staticClass:"car-name"},[_vm._v(" "+_vm._s(`${_vm.damage.carManufacturer} ${_vm.damage.carModel}`)),_c('span',{staticClass:"caryear"},[_vm._v("("+_vm._s(_vm.damage.carYear)+")")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }